import React, { useReducer } from 'react'
import { sessionStorage } from 'react-storage'
import DefaultLayout, {
  LayoutSpacingOptions,
} from '@src/components/DefaultLayout'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { homeRoute, fastDuplexOligosRoute, useRouter } from '@src/routes'
import { FormattedMessage, useIntl } from 'react-intl'
import PageHeader from '@src/routes/Configurators/components/PageHeader'
import ProductEntryTab from '@src/routes/Configurators/components/ProductEntryTab'
import FastSingleProductEntry from './FastDuplexOligos/Step1/FastSingleProductEntry'
import FastMultiProductEntry from '../BiTube/FastDuplexOligos/Step1/FastMultiProductEntry'
import SequenceEntry from './LightCyclerProbes/Step1/SequenceEntry'
import ConfirmOrder from './FastDuplexOligos/Step2/ConfirmOrder'
import { DialogContent } from '@material-ui/core'
import LeftNav from '@src/routes/Configurators/components/LeftNav'
import { initialState, reducer, ContextProps } from './Reducer'
import {
  useBitubeEditLinkQuery,
  useBitubeDataQuery,
  useGetProductInformationQuery,
  SpecificationsComponent,
} from '@src/queries/ConfiguratorTubesQuery.generated'
import { useCurrentUserQuery } from '@src/queries/CurrentUserQuery.generated'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { useUserSession } from '@utils/useUserSession'
import ReviewDialog from '../BiTube/FastDuplexOligos/Step2/ReviewDialog'
import {
  ActiveLinkType,
  BiTubeProduct,
  BitubeProperties,
  ProductHeader,
} from './enum'
import { default as UUID } from 'uuid'
import messages from '../../messages'
import ConfiguratorPageError from '@src/routes/Configurators/utils/ConfiguratorPageError'
import { TubeProperties } from '../../utils/enum'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { BreadcrumbNavigationUrls } from '@src/routes/Configurators/utils/BreadcrumbNavigationUrlsEnum'
import CircleLoader from '@src/components/CircleLoader/CircleLoader'
import {
  ConfiguratorProductDetails,
  ProductInformation,
  TubeEditLinkDetails,
} from '../ConfiguratorSharedTypes'
import Breadcrumb from '@src/components/Breadcrumb'

const useStyles = makeStyles((theme: Theme) => {
  return {
    labelHeaderEn: {
      verticalAlign: 'super',
      fontSize: theme.typography.pxToRem(18),
    },
    breadcrumbCSS: {
      verticalAlign: 'super',
      fontSize: theme.typography.pxToRem(12),
    },
  }
})

// Create context object
export const biTubeConfigContext = React.createContext({} as ContextProps)

const BiTube = () => {
  const router = useRouter()
  const classes = useStyles()
  const intl = useIntl()
  const [bitubeState, biTubeDispatch] = useReducer(reducer, initialState)
  const { userSession } = useUserSession()
  const [itemDetails, setItemDetails] = React.useState<any>([])
  const countryCd = userSession.country
  const { data, loading } = useCurrentUserQuery()
  const [addItemsFromSideNav, setAddItemsFromSideNav] = React.useState(false)
  const [sessionResp, setSessionResp] = React.useState<any>([])
  const [specificationData, setSpecificationData] = React.useState<any>()
  const [fetchApi, setFetchApi] = React.useState(false)
  const currentUser: any = data?.me || null
  //  if productCode  is 1 i.e product is unauthorized
  //                     2 i.e product is invalid
  //                     0 i.e product is valid
  const [productCode, setProductCode] = React.useState(0)
  const [isApiCall, setIsApiCall] = React.useState(true)
  let loggedIn
  if (!loading)
    loggedIn =
      currentUser && currentUser.__typename === BitubeProperties.LoggedInUser

  let participationId: string
  let locale: string
  let isCSR: boolean
  let isCSRSupervisor: boolean
  let isSAPNextEnabled: boolean
  let isOrderCustomer: boolean
  let isOrderableCustomer: boolean
  let isGuestShoppingCountry: boolean
  let isConfiguratorDisabled: boolean
  let activeLink = router?.query?.activeLink ?? ''
  const cartId = router?.query?.cartid ?? ''
  const itemId = router?.query?.itemid ?? ''
  const date = new Date()
  const timeZone = (date.getTimezoneOffset() / 60) * -1
  let { product = '' } = router.query
  if (product === BiTubeProduct.LightCyclerOld) {
    product = BiTubeProduct.LightCycler
  } else if (product === BiTubeProduct.FastDuplexOld) {
    product = BiTubeProduct.FastDuplex
  } else if (product === BiTubeProduct.mirnaOld) {
    product = BiTubeProduct.mirna
  }
  let accessToken = ''
  let store = ''
  if (userSession.accessToken) {
    accessToken = userSession.accessToken
  }
  if (userSession.store) {
    store = userSession.store
  }
  if (loggedIn && currentUser) {
    participationId = currentUser.id
    locale = `${userSession.language}_${countryCd}`
    if (locale === '') {
      locale = currentUser?.metadata.locale
    }
    isCSR = currentUser?.roles.isCustomerServiceRep
    isCSRSupervisor = currentUser?.roles.isCustomProductCSR
    isSAPNextEnabled = currentUser.metadata.isSAPNextEnabled
    isGuestShoppingCountry = currentUser.metadata.guestShoppingType
    isOrderCustomer =
      currentUser?.roles.isPublicOrderingCustomer ||
      currentUser?.roles.isQuoteRequester
    if (isGuestShoppingCountry !== null) {
      isOrderableCustomer = true
    } else if (isOrderCustomer && isGuestShoppingCountry === null) {
      isOrderableCustomer = true
    } else {
      isOrderableCustomer = false
    }
    isConfiguratorDisabled =
      currentUser.participantSitePreference?.hideOligoPeptideDesign
  } else if (userSession.accessToken) {
    participationId = userSession.accessToken
    locale = `${userSession.language}_${countryCd}`
    isCSR = false
    isCSRSupervisor = false
    isOrderableCustomer = false
    isSAPNextEnabled = currentUser?.metadata.isSAPNextEnabled
    isConfiguratorDisabled = false
  } else {
    //TODO: commented participationId as a part of fix for STRAT-11633
    //Identify why the page is going in an infinite loop when fetching the id dynamically.
    participationId = UUID.v4()
    locale = `en_${countryCd}`
    isCSR = false
    isCSRSupervisor = false
    isSAPNextEnabled = true
    isOrderableCustomer = false
    isConfiguratorDisabled = false
  }
  const orderPath = `${fastDuplexOligosRoute.index()}?product=${product}&activeLink=${
    ActiveLinkType.ConfirmOrder
  }`
  const sequencePath = `${fastDuplexOligosRoute.index()}?product=${product}&activeLink=${
    ActiveLinkType.SequenceEntry
  }`
  const tubeEditLinkDetails: TubeEditLinkDetails = {
    productType: product,
    participantId: participationId,
    countryCode: countryCd,
    cartId: cartId,
    cartItemId: itemId,
    store: store,
  }
  const productDetails: ConfiguratorProductDetails = {
    productType: product,
    participantId: participationId,
    countryCode: countryCd,
    isRegUser: loggedIn,
    locale: locale,
    isCSR: isCSR,
    isCSRSupervisor: isCSRSupervisor,
    sapNextEnabled: isSAPNextEnabled,
    timeZone: timeZone.toString(),
    store: store,
  }

  if (loggedIn) {
    const referrerParticipantId: string | null = sessionStorage.getItem(
      'CONFIGURATOR_REFERRER_ID'
    )
    if (referrerParticipantId) {
      productDetails.guestParticipantId = referrerParticipantId
    }
  }

  const [openError, setOpenError] = React.useState(false)
  const productInformation: ProductInformation = {
    productType: product,
    countryCode: countryCd,
    isCsr: isCSR,
    isCsrSupervisor: isCSRSupervisor,
    isOrderableCustomer: isOrderableCustomer,
    regUser: loggedIn,
    locale: locale,
    sapNextEnabled: isSAPNextEnabled,
    hideOligoPeptideDesign: isConfiguratorDisabled,
  }

  const { data: editLinkData } = useBitubeEditLinkQuery({
    variables: {
      product: tubeEditLinkDetails,
    },
    fetchPolicy: 'no-cache',
    skip: !accessToken || !(cartId && itemId),
    ssr: false,
  })

  const { data: sessionResponseData } = useBitubeDataQuery({
    variables: {
      product: productDetails,
    },
    fetchPolicy: 'no-cache',
    skip: !accessToken,
    ssr: false,
  })

  React.useEffect(() => {
    let sessionResp: any
    if (cartId && itemId && editLinkData) {
      sessionResp = editLinkData?.bitubeEditLink?.data
    } else {
      sessionResp = sessionResponseData?.getBitubeData?.data
    }
    setFetchApi(true)
    setSessionResp(sessionResp)
  }, [editLinkData, sessionResponseData])

  const validateActiveLink = (activeLink) => {
    return activeLink === '' || activeLink == null
      ? ActiveLinkType.SequenceEntry
      : activeLink
  }

  const setErrorData = (data) => {
    const index = data.length - 1
    if (data[index]) {
      return {
        name: data[index].name,
        sequence: data[index].sequence,
        scale: '',
        purification: data[index].purification,
        fiveMod: data[index].fiveMod,
        threeMod: data[index].threeMod,
        researcher: '',
        format: data[index].format,
        concentration: data[index].concentration,
        tubes: data[index].tubes,
        countryCode: countryCd,
        isOverridden: data[index].isOverridden,
        customerOverhang: data[index].customerOverhang,
        antisenceName: data[index].antisenceName,
        antisenceSequence: data[index].antisenceSequence,
        customerAntisenseOverHang: data[index].customerAntisenseOverHang,
        antisenceFiveMod: data[index].antisenceFiveMod,
        antisenceThreeMod: data[index].antisenceThreeMod,
        antisenceBaseCount: 0,
        amount: data[index].amount,
        autoGenerateOligo: data[index].autoGenerateOligo,
        senseNameCheck: data[index].senseNameCheck,
      }
    } else {
      return {
        name: '',
        sequence: '',
        scale: '',
        purification: '',
        fiveMod: '',
        threeMod: '',
        researcher: '',
        format: '',
        concentration: '',
        tubes: '',
        countryCode: '',
        customerOverhang: '',
        isOverridden: false,
        antisenceName: '',
        antisenceSequence: '',
        customerAntisenseOverHang: '',
        antisenceFiveMod: '',
        antisenceThreeMod: '',
        antisenceBaseCount: 0,
        amount: '',
        autoGenerateOligo: false,
        senseNameCheck: false,
      }
    }
  }
  let apiData: any = {}
  const FetchProductDetails = async (obj) => {
    const { data, loading } = useGetProductInformationQuery({
      variables: {
        input: obj,
      },
      fetchPolicy: 'no-cache',
    })
    if (!loading && loggedIn !== undefined) {
      apiData = data?.getProductInformation
    }
  }

  React.useEffect(() => {
    if (Object.keys(apiData).length !== 0 && isApiCall) {
      setIsApiCall(false)
      const {
        productType,
        shippingOptions,
        brand,
        companionProducts,
        instructions,
        displayName,
        packageType,
        typeCode,
        currencyFormat,
        decimalSeparator,
        thousandSeparator,
        prefixCurrecny,
        thousandSpacing,
      } = apiData

      if (displayName === TubeProperties.UnAuthorized) {
        setProductCode(1)
      } else if (displayName.includes(TubeProperties.InvalidProduct)) {
        setProductCode(2)
      } else if (displayName.includes(TubeProperties.ProductNotValid)) {
        setProductCode(3)
      } else if (displayName.includes(TubeProperties.UserCannotOrder)) {
        setProductCode(4)
      } else {
        setProductCode(0)
        const productData = {
          productType: productType,
          shippingOptions: shippingOptions,
          brand: brand,
          companionProducts: companionProducts,
          instructions: instructions,
          packageType: packageType,
          typeCode: typeCode,
          currencyFormat: currencyFormat,
          decimalSeparator: decimalSeparator,
          thousandSeparator: thousandSeparator,
          prefixCurrecny: prefixCurrecny,
          thousandSpacing: thousandSpacing,
        }
        biTubeDispatch({
          type: 'SET_PRODUCT_INFORMATION',
          data: productData,
        })
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [apiData])

  accessToken && FetchProductDetails(productInformation)

  React.useEffect(() => {
    biTubeDispatch({ type: 'INIT' })
  }, [])

  React.useEffect(() => {
    biTubeDispatch({
      type: 'UPDATE_SPECIFICATION_RESPONSE',
      data: specificationData,
    })
  }, [specificationData])

  const displayErrorPopUpOnReview = () => {
    if (bitubeState.isSideNavLinkDisabled) {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
      })
    } else {
      biTubeDispatch({ type: 'SET_PAGE_ERROR', data: '' })
    }
  }

  React.useEffect(() => {
    if (sessionResp && fetchApi) {
      let hasError = false
      if (sessionResp.length > 0) {
        sessionResp.forEach((item, index) => {
          delete item.__typename
          item.listError.forEach((error) => {
            delete error.__typename
            hasError = true
          })
          //if the last oligo has error then it must be displayed against the fields
          if (index === sessionResp.length - 1 && item.listError.length > 0) {
            if (
              sessionResp.length === 1 &&
              item.name === '' &&
              item.sequence === '' &&
              item.antisenceName === '' &&
              item.antisenceSequence === ''
            ) {
              biTubeDispatch({ type: 'SET_ERROR_ON_PAGE_REFRESH', data: false })
              biTubeDispatch({
                type: 'SPECIFICATION_TOTAL_VALIDATION',
                data: false,
              })
              biTubeDispatch({ type: 'SET_ERROR_ICON_ON_PAGELOAD', data: true })
            } else {
              biTubeDispatch({
                type: 'SPECIFICATION_TOTAL_VALIDATION',
                data: true,
              })
              biTubeDispatch({ type: 'SET_ERROR_ON_PAGE_REFRESH', data: true })
            }
          }
        })
        if (hasError) {
          biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
        } else {
          biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: true })
        }
        biTubeDispatch({
          type: 'COUNTRY_CODE',
          data: countryCd,
        })
        biTubeDispatch({
          type: 'UPDATE_INPUT',
          data: sessionResp,
        })
        biTubeDispatch({
          type: 'IS_SESSION_LOADED',
          data: true,
        })
        biTubeDispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: sessionResp.length - 1,
        })
        biTubeDispatch({
          type: 'ADD_NEW_OLIGO',
          data: sessionResp.length - 1,
        })
        biTubeDispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: sessionResp.length - 1,
        })
        biTubeDispatch({
          type: 'UPDATE_PAGE_LOAD',
          data: 1,
        })
        biTubeDispatch({
          type: 'IS_PAGE_RELOAD',
          data: true,
        })
        biTubeDispatch({
          type: 'UPDATE_ERROR_DATA',
          data: setErrorData(sessionResp),
        })
        biTubeDispatch({
          type: 'SET_CONTINUE_TO_NEXT_PAGE',
          data: false,
        })
        if (
          activeLink === ActiveLinkType.ReviewPage &&
          sessionResp.length === 1 &&
          sessionResp[0].name === '' &&
          sessionResp[0].sequence === '' &&
          sessionResp[0].antisenceName === '' &&
          sessionResp[0].antisenceSequence === ''
        ) {
          router.push(sequencePath)
        }
      } else {
        biTubeDispatch({
          type: 'SET_CONTINUE_TO_NEXT_PAGE',
          data: true,
        })
        biTubeDispatch({
          type: 'IS_SESSION_LOADED',
          data: true,
        })
        if (activeLink === ActiveLinkType.ReviewPage) {
          router.push(sequencePath)
        }
      }
      if (cartId && itemId) {
        router.replace(sequencePath)
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [sessionResp])

  React.useEffect(() => {
    if (bitubeState.pageError.length === 0) {
      setOpenError(false)
    } else {
      setOpenError(true)
    }
  }, [bitubeState.pageError])

  React.useEffect(() => {
    return function cleanupError() {
      !loggedIn
        ? sessionStorage.setItem(
            'CONFIGURATOR_REFERRER_ID',
            productDetails.participantId
          )
        : sessionStorage.removeItem('CONFIGURATOR_REFERRER_ID')
    }
  }, [])

  activeLink = validateActiveLink(activeLink)

  const breadcrumbItems = [
    {
      url: homeRoute.index(),
      label: <FormattedMessage {...messages[`CONF_HOME_${product}`]} />,
    },
    {
      url: BreadcrumbNavigationUrls.BreadcrumbCustomProducts,
      label: (
        <FormattedMessage {...messages[`CONF_CUSTOM_PRODUCT_${product}`]} />
      ),
    },
    {
      url: BreadcrumbNavigationUrls[`Breadcrumb_${product}`],
      label: (
        <FormattedMessage
          {...messages[`CONF_CUSTOM_PRODUCT_NAME_${product}`]}
        />
      ),
    },
    {
      url: '',
      label: (
        <FormattedMessage
          {...messages[`CONF_BITUBE_PRODUCT_NAME_${product}`]}
          values={{
            registered: (
              <sup>
                <FormattedMessage {...messages.CONF_TRADEMARK} />
              </sup>
            ),
          }}
        />
      ),
    },
  ]

  const sidebarItems = [
    {
      label: intl.formatMessage(messages.CONF_SEQUENCE_ENTRY),
      activeLink:
        activeLink === ActiveLinkType.SequenceEntry ||
        activeLink === ActiveLinkType.ReviewPage
          ? true
          : false,
      url: `${fastDuplexOligosRoute.index()}?product=${product}&activeLink=${
        ActiveLinkType.SequenceEntry
      }`,
      linkDisable: false,
      linkNotClickable: bitubeState.bulkReview,
    },
    {
      label: intl.formatMessage(messages.CONF_CONFIRM_ORDER),
      activeLink: activeLink === ActiveLinkType.ConfirmOrder ? true : false,
      url: `${fastDuplexOligosRoute.index()}?product=${product}&activeLink=${
        ActiveLinkType.ConfirmOrder
      }`,
      linkDisable: !bitubeState.confirmOrder,
      linkNotClickable: false,
    },
  ]
  //let fastDuplexComponent
  let productHeader
  //assign product header based on the product type
  if (product === BiTubeProduct.Duplex) {
    productHeader = ProductHeader.Duplex
  }
  if (product === BiTubeProduct.FastDuplex) {
    productHeader = ProductHeader.FastDuplex
  }
  if (product === BiTubeProduct.mirna) {
    productHeader = ProductHeader.Mirna
  }

  const navigateToConfirm = () => {
    router.push(orderPath)
  }
  const setActive = (id) => {
    if (activeLink === ActiveLinkType.ConfirmOrder) {
      router.push(sequencePath)
    }
    biTubeDispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: id,
    })
    biTubeDispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
  }

  const biTubeContentComponent = (getSpecifications) => {
    if (
      activeLink === ActiveLinkType.SequenceEntry ||
      activeLink === ActiveLinkType.MultipleEntry
    ) {
      if (product === BiTubeProduct.LightCycler) {
        return (
          <div>
            <DialogContent>
              <ErrorAlert
                open={openError}
                setOpen={setOpenError}
                message={bitubeState.pageError}
              />
            </DialogContent>
            <SequenceEntry
              productDetails={productDetails}
              setActive={setActive}
              setItemDetails={setItemDetails}
            />
          </div>
        )
      } else {
        //for duplex and fastfuplex
        return (
          <div>
            <DialogContent>
              <ErrorAlert
                open={openError}
                setOpen={setOpenError}
                message={bitubeState.pageError}
              />
            </DialogContent>
            <ProductEntryTab
              singleProductEntry={
                <FastSingleProductEntry
                  productDetails={productDetails}
                  setActive={setActive}
                  setAddItemsFromSideNav={setAddItemsFromSideNav}
                  setItemDetails={setItemDetails}
                  specifications={getSpecifications}
                />
              }
              multiProductEntry={
                <FastMultiProductEntry
                  navigateToConfirm={navigateToConfirm}
                  productDetails={productDetails}
                  setAddItemsFromSideNav={setAddItemsFromSideNav}
                  setItemDetails={setItemDetails}
                />
              }
            />
          </div>
        )
      }
    }

    if (activeLink === ActiveLinkType.ConfirmOrder)
      return (
        <ConfirmOrder
          productDetails={productDetails}
          itemDetails={itemDetails}
        />
      )

    if (activeLink === ActiveLinkType.ReviewPage)
      return (
        <ReviewDialog
          productDetails={productDetails}
          setItemDetails={setItemDetails}
        />
      )

    return null
  }

  return (
    <biTubeConfigContext.Provider value={{ bitubeState, biTubeDispatch }}>
      <SpecificationsComponent
        ssr={false}
        variables={{
          product: productDetails,
        }}
      >
        {({ loading, error, data }) => {
          if (loading) return <CircleLoader />
          if (error || !data || !data.getSpecifications) return null
          const { getSpecifications } = data
          setSpecificationData(getSpecifications)
          return (
            <DefaultLayout spacing={LayoutSpacingOptions.MD}>
              {productCode !== 0 ? (
                <ConfiguratorPageError
                  productCode={productCode}
                  country={countryCd}
                />
              ) : (
                <Container>
                  <Breadcrumb items={breadcrumbItems} />
                  <PageHeader
                    label={
                      product === BiTubeProduct.LightCycler ? (
                        <div>
                          {ProductHeader.Lightcycle1}
                          <span className={classes.labelHeaderEn}>
                            <FormattedMessage {...messages.CONF_TRADEMARK} />
                          </span>
                          &nbsp;
                          {ProductHeader.Lightcycle2}
                        </div>
                      ) : (
                        productHeader
                      )
                    }
                  />
                  <Grid container spacing={10}>
                    <Grid item xs={3}>
                      {bitubeState.confirmOrder ? (
                        <LeftNav
                          sidebarItems={sidebarItems}
                          productType={BiTubeProduct.BiTube}
                          addProductsFromSideNav={addItemsFromSideNav}
                          setActive={setActive}
                          activeStep={1}
                          productDetails={productDetails}
                          isNotNavigateable={bitubeState.isSideNavLinkDisabled}
                          displayErrorPopUpOnReview={displayErrorPopUpOnReview}
                        />
                      ) : (
                        <LeftNav
                          sidebarItems={sidebarItems}
                          productType={BiTubeProduct.BiTube}
                          addProductsFromSideNav={addItemsFromSideNav}
                          setActive={setActive}
                          activeStep={0}
                          productDetails={productDetails}
                          isNotNavigateable={bitubeState.isSideNavLinkDisabled}
                          displayErrorPopUpOnReview={displayErrorPopUpOnReview}
                        />
                      )}
                    </Grid>
                    <Grid item xs={9}>
                      <div>{biTubeContentComponent(getSpecifications)}</div>
                    </Grid>
                  </Grid>
                </Container>
              )}
            </DefaultLayout>
          )
        }}
      </SpecificationsComponent>
    </biTubeConfigContext.Provider>
  )
}

export default BiTube
